//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service'
import BuildingService from '@/service/building'
import detailSubPage from '@/common/mixins/detailSubPage'

import CommonFooter from '../_components/_common_footer'

export default {
    mixins: [
        detailSubPage
    ],
    components: {
        CommonFooter,
    },
    data () {
        return {
            house: {},
            current_house: {},
            loading: true,
            reg_step_link: '/reg_step/main',
            excellent_consultants: []
        }
    },
    computed: {
        ln_verify_date () {
            return this.getDateStr(['ln_verify_start_date', 'ln_verify_end_date'])
        },
        ln_register_date () {
            return this.getDateStr(['ln_register_start_date', 'ln_register_end_date'])
        },
        ln_publicity_date () {
            return this.getDateStr(['ln_publicity_start_date', 'ln_publicity_end_date'])
        },
        apartment_selection_date () {
            return this.getDateStr(['apartment_selection_start_date', 'apartment_selection_end_date'])
        }
    },
    created () {
        this.getData()
    },
    methods: {
        getDateStr (arr) {
            return arr.map(key => this.current_house[key]).filter(val => val).join(' ~ ')
        },
        getData () {
            this.$wx.showLoading()
            const { building_id, house_id } = this.$route.query
            Service.getBuilding(building_id, house_id).then((data) => {
                this.house = data
                let current_house = {}
                if (Number(building_id) === 490) {
                    this.reg_step_link = ''
                    // this.reg_step_link = `/web_page?link=${encodeURIComponent('https://mp.weixin.qq.com/s/Ra4IxNDzbvQaIhLqYPqhRw')}&title=${this.house.name}`
                }
                data.current_houses.some((house) => {
                    if (house.id == house_id) {
                        current_house = house
                        return true
                    }
                })
                data.current_houses.forEach((item) => {
                    item.has_house_price = item.exist_values && item.exist_values.indexOf('house_prices') > -1
                })
                const date_key = [
                    'apartment_selection_start_date',
                    'apartment_selection_end_date',
                    'created_date',
                    'ln_date',
                    'ln_publicity_start_date',
                    'ln_publicity_end_date',
                    'ln_register_start_date',
                    'ln_register_end_date',
                    'ln_verify_start_date',
                    'ln_verify_end_date'
                ]
                date_key.forEach((key) => {
                    if (current_house[key]) {
                        current_house[key] = current_house[key].replace(/-/g, '.')
                    }
                })
                this.current_house = current_house
                this.loading = false
                this.$wx.hideLoading()
            })
        },
        goMap (e) {
            const { address } = e.currentTarget.dataset
            const locations = this.house.location.split(',').map(item => Number(item))
            const longitude = locations[0]
            const latitude = locations[1]
            if (latitude && longitude) {
                this.$router.push({
                    name: 'map',
                    query: {
                        latitude,
                        longitude,
                        name: this.house.name,
                        address
                    }
                })
            }
        },
        goResult (e) {
            const { type } = e.currentTarget.dataset
            const { id: building_id, name } = this.house
            const { id: house_id } = this.current_house
            this.$router.push({
                path:`/building/result?building_id=${building_id}&house_id=${house_id}&name=${name}&type=${type}`
            })
        },
        openRegRule () {
            this.downloadDoc(this.current_house.attachment_urls.rule)
        },
        previewImg (url) {
            this.$router.push({
                path:`/building/material/preview?url=${encodeURIComponent(url)}`
            })
        },
        downloadDoc (url) {
            if (url.search(/\.(png|jpg|jpeg|gif|bmp)/) > -1) {
                this.$wx.previewImage({
                    current: url,
                    urls: [url]
                })
                return
            }
            this.$wx.showLoading && this.$wx.showLoading()
            const str_arr = url.split('.')
            const ext = str_arr[str_arr.length - 1]
            const filePath = wx.env.USER_DATA_PATH + '/' + 'attachment' + new Date().getTime() + '.' + ext
            wx.downloadFile({
                url,
                filePath,
                success () {
                    wx.openDocument({
                        filePath,
                        complete () {
                            wx.hideLoading()
                        }
                    })
                },
                fail (err) {
                    this.$wx.hideLoading()
                    console.error(err)
                }
            })
        },
    }
}
